var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm.serviceRequest && _vm.order
      ? _c(
          "section",
          { staticClass: "py-4" },
          [
            _vm.user && Number(_vm.user.id) === Number(_vm.order.user_id)
              ? [
                  _c("div", { staticClass: "row pb-4" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "text-primary-link",
                            attrs: {
                              to: _vm.isLineLoggedIn
                                ? "/line-liff/bookings"
                                : "/my-reservations"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("message.menu.my_reservations"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("i", { staticClass: "fal fa-angle-right" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "message.my_reservations.service_request_detail"
                              )
                            ) +
                            "\n        "
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.serviceRequest.payment_status === 0
                    ? _c(
                        "div",
                        { staticClass: "pb-4" },
                        [
                          _c("progress-bar", {
                            attrs: {
                              serviceRequestStates: _vm.serviceRequestStates,
                              step: _vm.serviceRequest.step_data
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row pb-3 d-flex h-100" }, [
                    _c("div", { staticClass: "col-8 align-self-center" }, [
                      _c("label", { staticClass: "m-0" }, [
                        _vm._v(
                          "\n            #" + _vm._s(_vm.order.code) + " - "
                        ),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$options.filters.serviceParentName(
                                _vm.order.service_id,
                                _vm.globalState.services
                              )
                            )
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-4 text-right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn-outline-info btn",
                          attrs: {
                            href: "https://line.me/R/ti/p/%40hnk7011n",
                            target: "_blank"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("message.button.contact_admin")))]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.serviceRequest.payment_status === 1
                    ? _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "alert alert-info alert-dismissible fade show",
                              attrs: { role: "alert" }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.service_request.service_request_remaining_balance_notification"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _vm._m(0)
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-8" }, [
                      _c(
                        "section",
                        [
                          _c("confirm-offer-section", {
                            attrs: {
                              serviceRequest: _vm.serviceRequest,
                              serviceRequestLostSalesReasons:
                                _vm.serviceRequestLostSalesReasons
                            },
                            on: { confirmDialogAction: _vm.confirmDialogAction }
                          }),
                          _vm._v(" "),
                          _c("payment-section", {
                            attrs: { serviceRequest: _vm.serviceRequest },
                            on: { openPaymentDialog: _vm.openPaymentDialog }
                          }),
                          _vm._v(" "),
                          _c("received-order-section", {
                            attrs: { order: _vm.order }
                          }),
                          _vm._v(" "),
                          _c("review-section", { attrs: { order: _vm.order } }),
                          _vm._v(" "),
                          _vm.order &&
                          _vm.order.status === 2 &&
                          _vm.order.order_photos &&
                          _vm.order.sent_photo_status === 1
                            ? _c("section", [
                                _c("div", { staticClass: "card panel-white" }, [
                                  _c(
                                    "div",
                                    { staticClass: "card-body" },
                                    [
                                      _c("div", { staticClass: "mb-2" }, [
                                        _c("label", [
                                          _c("i", {
                                            staticClass: "fal fa-images"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.my_reservations.completed_cleaning_photos"
                                                )
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("photos-album", {
                                        attrs: {
                                          photos: _vm.order.order_photos,
                                          photoType: "order_photos",
                                          includeGallery: false
                                        },
                                        on: { onItemClick: _vm.setGalleryIndex }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$mq.phone
                            ? _c("professional-section", {
                                attrs: {
                                  order: _vm.order,
                                  serviceRequest: _vm.serviceRequest
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "card panel-white" }, [
                            _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-md-3 text-left" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "message.service_request.status"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-9" }, [
                                  _c("i", {
                                    staticClass:
                                      "fas fa-circle fa-sm -status-pending"
                                  }),
                                  _vm._v(
                                    " \n                    " +
                                      _vm._s(
                                        _vm._f("multiLangName")(
                                          _vm.serviceRequest
                                            .service_request_status
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-md-3" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.service_request.service_date"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-9" }, [
                                  _vm.serviceRequest.is_confirmed === 0
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("prettyDate")(
                                                _vm.serviceRequest.service_date
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm.serviceRequest.actual_service_date
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm._f("prettyDate")(
                                                      _vm.serviceRequest
                                                        .actual_service_date
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm._f("prettyDate")(
                                                      _vm.serviceRequest
                                                        .offered_service_date
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ])
                                      ])
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.serviceRequest.offered_service_date &&
                              _vm.serviceRequest.is_confirmed === 0
                                ? _c(
                                    "div",
                                    { staticClass: "row no-gutters mt-3" },
                                    [
                                      _c("div", { staticClass: "col-md-3" }, [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.service_request.service_request_provider_offered_service_date"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-9 -status-new" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm._f("prettyDate")(
                                                  _vm.serviceRequest
                                                    .offered_service_date
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.serviceRequest.offered_service_date &&
                              _vm.serviceRequest.is_confirmed === 0
                                ? _c(
                                    "div",
                                    { staticClass: "row no-gutters mt-3" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col text-remark" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-circle fa-sm -status-pending"
                                          }),
                                          _vm._v(
                                            " \n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.service_request.service_request_service_date_remark"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.serviceRequest.duration_remark
                                ? _c(
                                    "div",
                                    { staticClass: "row no-gutters mt-3" },
                                    [
                                      _c("div", { staticClass: "col-md-3" }, [
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.service_request.service_request_duration_remark"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-9" }, [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.serviceRequest.duration_remark
                                            ) +
                                            "\n                  "
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _vm.serviceRequest.service_request_purpose
                              ? _c("div", { staticClass: "card-body" }, [
                                  _c("div", { staticClass: "row no-gutters" }, [
                                    _c("div", { staticClass: "col-md-3" }, [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "message.service_request.purpose"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm._f("multiLangName")(
                                              _vm.serviceRequest
                                                .service_request_purpose
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.serviceRequest.building_type != null ||
                            _vm.serviceRequest.building_size != null
                              ? _c("div", { staticClass: "card-body" }, [
                                  _c("div", { staticClass: "row no-gutters" }, [
                                    _c("div", { staticClass: "col-md-3" }, [
                                      _vm.serviceRequest.building_type
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.service_request.building_type"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ])
                                        : _c("label", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.service_request.furniture_detail"
                                                  )
                                                ) +
                                                "\n                    "
                                            )
                                          ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm.serviceRequest.building_type
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm._f("multiLangName")(
                                                    _vm.serviceRequest
                                                      .building_type
                                                  )
                                                ) +
                                                " - " +
                                                _vm._s(
                                                  _vm.serviceRequest
                                                    .building_size
                                                ) +
                                                "\n                    "
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.serviceRequest
                                                    .building_size
                                                ) +
                                                "\n                    "
                                            )
                                          ])
                                    ])
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-body" }, [
                              _c("div", { staticClass: "row no-gutters" }, [
                                _c("div", { staticClass: "col-md-3" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.service_request.address"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-9" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.serviceRequest.building_address
                                      ) +
                                      "\n                    "
                                  ),
                                  _vm.serviceRequest.sub_district
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("multiLangName")(
                                                _vm.serviceRequest.sub_district
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm._f("multiLangName")(
                                          _vm.serviceRequest.district
                                        )
                                      ) +
                                      "\n                    " +
                                      _vm._s(
                                        _vm._f("multiLangName")(
                                          _vm.serviceRequest.address_province
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.serviceRequest.remark
                              ? _c("div", { staticClass: "card-body" }, [
                                  _c("div", { staticClass: "row no-gutters" }, [
                                    _c("div", { staticClass: "col-md-3" }, [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "message.service_request.remark"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-9" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.serviceRequest.remark) +
                                          "\n                  "
                                      )
                                    ])
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.serviceRequest.service_request_photos.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "card-body" },
                                  [
                                    _c("label", [
                                      _c("i", { staticClass: "fal fa-images" }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.service_request.photos"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("photos-album", {
                                      attrs: {
                                        photos:
                                          _vm.serviceRequest
                                            .service_request_photos,
                                        photoType: "service_request_photos",
                                        includeGallery: false
                                      },
                                      on: { onItemClick: _vm.setGalleryIndex }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.serviceRequest.service_cost
                              ? _c(
                                  "div",
                                  { staticClass: "card-body" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "row no-gutters" },
                                      [
                                        _c("div", { staticClass: "col-6" }, [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.service_request.service_cost"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-6 text-right" },
                                          [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    _vm.serviceRequest
                                                      .service_cost
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "row no-gutters" },
                                      [
                                        _c("div", { staticClass: "col-6" }, [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.service_request.service_request_payment_status"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-6 text-right" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.serviceRequest
                                                    .payment_status === 2
                                                    ? "-status-new"
                                                    : "text-orange"
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "serviceRequestPaymentStatus"
                                                      )(
                                                        _vm.serviceRequest
                                                          .payment_status
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.serviceRequest.payment_status === 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "row no-gutters mt-3"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-6" },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.service_request.service_request_remaining_balance"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-6 text-right",
                                                staticStyle: {
                                                  "font-weight": "bold"
                                                }
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        parseFloat(
                                                          _vm.serviceRequest
                                                            .service_cost / 2
                                                        ).toFixed(2)
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 text-remark"
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-circle fa-sm -status-pending"
                                                }),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.service_request.service_request_remaining_balance_remark"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.serviceRequest.service_request_payments
                                      .length > 0
                                      ? [
                                          _c("hr", { staticClass: "my-4" }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "row no-gutters my-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-12 text-remark"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.booking.payment_step.payment"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.serviceRequest
                                              .service_request_payments,
                                            function(payment, index) {
                                              return _c(
                                                "div",
                                                { key: payment.id },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row no-gutters"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-6"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "message.service_request.payment_type"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-6 text-right"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "serviceRequestPaymentType"
                                                                )(
                                                                  payment.payment_type
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row no-gutters mt-2"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-6"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "message.service_request.service_request_paid_on"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-6 text-right"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "prettyDate"
                                                                )(
                                                                  payment.created_at
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row no-gutters mt-2"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-6"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "message.service_request.status"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-6 text-right"
                                                        },
                                                        [
                                                          payment.status === 1
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "-status-new"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "message.my_reservations.already_paid"
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-orange"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "message.service_request.order_status_waiting_confirm"
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row no-gutters mt-2"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-6"
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "message.service_request.all_total_cost"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-6 text-right"
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currency"
                                                                )(
                                                                  _vm.getTotalCost(
                                                                    payment
                                                                  )
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row no-gutters"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-12"
                                                        },
                                                        [
                                                          _c("span", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$options.filters.orderPaymentData(
                                                                  payment.payment_data
                                                                )
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  index + 1 !==
                                                  _vm._.size(
                                                    _vm.serviceRequest
                                                      .service_request_payments
                                                  )
                                                    ? _c("hr")
                                                    : _vm._e()
                                                ]
                                              )
                                            }
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4" },
                      [
                        !_vm.$mq.phone
                          ? _c("professional-section", {
                              attrs: {
                                order: _vm.order,
                                serviceRequest: _vm.serviceRequest
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isLineLoggedIn
                    ? _c(
                        "div",
                        { staticClass: "container text-center py-2" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/line-liff/bookings" } },
                            [
                              _c("i", { staticClass: "fas fa-angle-left" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("message.booking.new_booking.back")
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("Tinybox", {
                    attrs: { images: _vm.images, loop: "", "no-thumbs": "" },
                    model: {
                      value: _vm.indexImage,
                      callback: function($$v) {
                        _vm.indexImage = $$v
                      },
                      expression: "indexImage"
                    }
                  }),
                  _vm._v(" "),
                  _c("payment-modal", {
                    ref: "paymentModal",
                    attrs: {
                      order: _vm.order,
                      serviceRequest: _vm.serviceRequest
                    },
                    on: { fetchData: _vm.getServiceRequest }
                  })
                ]
              : [
                  Number(_vm.user.id) !== Number(_vm.order.user_id)
                    ? _c("div", { staticClass: "p-4" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col text-center" }, [
                            _c("h3", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.my_reservations.cannot_view_other_user_reservation"
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      ])
                    : _vm._e()
                ]
          ],
          2
        )
      : _c("section", [_c("loader")], 1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "alert",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-398ef220", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-398ef220","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/serviceRequest/ServiceRequestDetail.vue
// module id = 2184
// module chunks = 0